import React from 'react';
import Banner from '../components/common/Banner';

const TermsConditionsPage = () => {
  return (
    <div className="h-full w-full fade-in">
      <Banner 
        title="Terms & Conditions"
        subtitle="Please read these terms and conditions carefully before using our services"
        imageSrc="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
      />
      
      <div className="max-w-4xl mx-auto p-6 md:p-10 space-y-8">
        {/* Terms & Conditions Section */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-12">
          <h1 className="text-3xl font-sans font-bold text-slate mb-4">TERMS & CONDITIONS</h1>
          <p className="text-sm text-gray-600 mb-6">
            FIT Engineering College, Meerut, Uttar Pradesh (Affiliated to AKTU & BTE)<br/>
            <strong>Effective Date:</strong> 01-Apr-2025
          </p>

          {/* 1. Introduction */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">1. Introduction</h2>
            <p className="text-gray-600 leading-relaxed">
              Welcome to the official website of FIT Engineering College, Meerut, Uttar Pradesh ("the College", "we", "our", "us"). 
              By accessing or using our website, you ("user", "student", "visitor", "parent/guardian") agree to comply with the 
              following Terms & Conditions. If you do not agree, please discontinue using the website immediately.
            </p>
          </section>

          {/* 2. Eligibility */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">2. Eligibility</h2>
            <p className="text-gray-600 leading-relaxed">
              The website is intended for students, parents, faculty members, staff, and other stakeholders seeking information 
              about the College, its programs, admissions, services, and activities.
            </p>
          </section>

          {/* 3. Use of Website */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">3. Use of Website</h2>
            <ul className="list-disc ml-6 space-y-2 text-gray-600">
              <li>Users must access the website only for lawful purposes.</li>
              <li>Any attempt to disrupt, damage, or interfere with website functionality is strictly prohibited.</li>
              <li>Users must not attempt to access unauthorised areas of the website, servers, or databases.</li>
              <li>Information provided on the website is for general reference and may be updated from time to time.</li>
            </ul>
          </section>

          {/* 4. Academic Information */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">4. Academic Information</h2>
            <ul className="list-disc ml-6 space-y-2 text-gray-600">
              <li>Details regarding courses, fee structures, syllabi, examination rules, and affiliations with AKTU and BTE are subject to revision based on governing body notifications.</li>
              <li>The College does not guarantee the accuracy or completeness of academic information at all times. Users are advised to regularly check for updates.</li>
            </ul>
          </section>

          {/* 5. Admissions */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">5. Admissions</h2>
            <ul className="list-disc ml-6 space-y-2 text-gray-600">
              <li>Admissions are governed by the rules and procedures outlined by AKTU, BTE, and regulatory authorities.</li>
              <li>Submission of false documents or misrepresentation may result in cancellation of admission.</li>
            </ul>
          </section>

          {/* 6. Intellectual Property Rights */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">6. Intellectual Property Rights</h2>
            <ul className="list-disc ml-6 space-y-2 text-gray-600">
              <li>All website content—including text, graphics, logos, images, videos, downloadable materials, and software—is owned by FIT Engineering College or used under licence.</li>
              <li>Users may not copy, reproduce, modify, publish, transmit, or distribute content without prior written consent.</li>
            </ul>
          </section>

          {/* 7. Third-Party Links */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">7. Third-Party Links</h2>
            <p className="text-gray-600 leading-relaxed mb-2">
              The website may contain links to external websites. The College is not responsible for:
            </p>
            <ul className="list-disc ml-6 space-y-1 text-gray-600">
              <li>content,</li>
              <li>accuracy,</li>
              <li>privacy practices,</li>
              <li>security</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mt-2">
              of third-party websites. Users access these at their own risk.
            </p>
          </section>

          {/* 8. Payments and Fees */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">8. Payments and Fees</h2>
            <ul className="list-disc ml-6 space-y-2 text-gray-600">
              <li>Online payments made through the website must be accurate and based on official communication from the College.</li>
              <li>The College is not responsible for payment failures caused by payment gateways, banks, or network issues.</li>
              <li>Fees once paid may be non-refundable, except as per the College's refund policy or regulatory guidelines.</li>
            </ul>
          </section>

          {/* 9. Limitation of Liability */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">9. Limitation of Liability</h2>
            <p className="text-gray-600 leading-relaxed mb-2">
              The College is not liable for:
            </p>
            <ul className="list-disc ml-6 space-y-1 text-gray-600">
              <li>accidental data loss,</li>
              <li>website downtime,</li>
              <li>inaccuracies in published information,</li>
              <li>indirect or consequential damages</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mt-2">
              arising from use of the website.
            </p>
          </section>

          {/* 10. Indemnity */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">10. Indemnity</h2>
            <p className="text-gray-600 leading-relaxed">
              Users agree to indemnify and hold harmless the College, its management, faculty, staff, and affiliates from 
              claims arising due to misuse of the website or violation of these Terms.
            </p>
          </section>

          {/* 11. Privacy */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">11. Privacy</h2>
            <p className="text-gray-600 leading-relaxed">
              Use of the website is subject to our Privacy Policy. By accessing the website, you consent to data collection 
              and processing in accordance with that policy.
            </p>
          </section>

          {/* 12. Changes to Terms */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">12. Changes to Terms</h2>
            <p className="text-gray-600 leading-relaxed">
              The College reserves the right to modify these Terms & Conditions anytime without prior notice. Continued use 
              of the website constitutes acceptance of updated terms.
            </p>
          </section>

          {/* 13. Governing Law */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">13. Governing Law</h2>
            <p className="text-gray-600 leading-relaxed">
              These Terms shall be governed by the laws of India, specifically applicable within Uttar Pradesh.
            </p>
          </section>

          {/* 14. Contact Information */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">14. Contact Information</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              For queries related to these Terms, users may contact:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700 font-semibold mb-2">FIT Engineering College</p>
              <p className="text-gray-600 mb-2">Kaseru Baxur, Green Park, Mawana Road, Meerut, Uttar Pradesh, India</p>
              <p className="text-gray-600">
                <i className="fas fa-envelope mr-2 text-crimson"></i>Email: info@fitenggmeerut.com
              </p>
              <p className="text-gray-600">
                <i className="fas fa-phone mr-2 text-crimson"></i>Phone: 8077185886
              </p>
            </div>
          </section>
        </div>

        {/* Privacy Policy Section */}
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-sans font-bold text-slate mb-4">PRIVACY POLICY</h1>
          <p className="text-sm text-gray-600 mb-6">
            FIT Engineering College, Meerut, Uttar Pradesh (Affiliated to AKTU & BTE)<br/>
            <strong>Effective Date:</strong> 01-APR-2025
          </p>

          {/* 1. Introduction */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">1. Introduction</h2>
            <p className="text-gray-600 leading-relaxed">
              FIT Engineering College ("the College") is committed to protecting the privacy and personal data of students, 
              parents, faculty, staff, applicants, and website visitors. This Privacy Policy outlines how we collect, use, 
              store, share, and safeguard personal information.
            </p>
          </section>

          {/* 2. Information We Collect */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">2. Information We Collect</h2>
            
            <h3 className="text-lg font-semibold text-slate mb-2 mt-4">2.1 Automatically Collected Information</h3>
            <p className="text-gray-600 mb-2">When you visit our website, we may collect:</p>
            <ul className="list-disc ml-6 space-y-1 text-gray-600">
              <li>IP addresses</li>
              <li>Browser type and version</li>
              <li>Device information</li>
              <li>Pages visited</li>
              <li>Date and time of access</li>
              <li>Cookies and analytics data</li>
            </ul>

            <h3 className="text-lg font-semibold text-slate mb-2 mt-4">2.2 Information Provided by Users</h3>
            <p className="text-gray-600 mb-2">We may collect personal information when users fill forms or interact with the website:</p>
            <ul className="list-disc ml-6 space-y-1 text-gray-600">
              <li>Name</li>
              <li>Email address</li>
              <li>Mobile number</li>
              <li>Address</li>
              <li>Academic details</li>
              <li>Application/Admission data</li>
              <li>Payment information (processed securely through third-party gateways)</li>
              <li>Feedback or enquiry information</li>
            </ul>

            <h3 className="text-lg font-semibold text-slate mb-2 mt-4">2.3 Student Information</h3>
            <p className="text-gray-600 mb-2">For enrolled students, additional data may be collected:</p>
            <ul className="list-disc ml-6 space-y-1 text-gray-600">
              <li>Academic records</li>
              <li>Attendance data</li>
              <li>Examination results</li>
              <li>Course selections</li>
              <li>ID proofs and documents</li>
            </ul>
          </section>

          {/* 3. How We Use Personal Information */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">3. How We Use Personal Information</h2>
            <p className="text-gray-600 mb-2">Personal data may be used for:</p>
            <ul className="list-disc ml-6 space-y-1 text-gray-600">
              <li>Admissions processing</li>
              <li>Communication with students and parents</li>
              <li>Providing academic and administrative services</li>
              <li>Fee collection and accounting</li>
              <li>Placement activities</li>
              <li>Website improvement and analytics</li>
              <li>Regulatory compliance (AKTU, BTE, AICTE, Govt. of India)</li>
              <li>Security and fraud prevention</li>
            </ul>
          </section>

          {/* 4. Sharing of Information */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">4. Sharing of Information</h2>
            <p className="text-gray-600 mb-2">Information may be shared with:</p>
            <ul className="list-disc ml-6 space-y-1 text-gray-600">
              <li>Affiliation and regulatory bodies (AKTU, BTE, AICTE)</li>
              <li>Payment gateway service providers</li>
              <li>Government authorities when legally required</li>
              <li>Accredited third-party service providers for hosting, analytics, or communication services</li>
            </ul>
            <p className="text-gray-600 mt-2 font-medium">We do not sell personal information.</p>
          </section>

          {/* 5. Data Retention */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">5. Data Retention</h2>
            <p className="text-gray-600 leading-relaxed">
              The College retains personal data only as long as required for academic, administrative, financial, and legal purposes. 
              Student records may be retained for statutory periods.
            </p>
          </section>

          {/* 6. Data Security */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">6. Data Security</h2>
            <p className="text-gray-600 mb-2">We use reasonable administrative, technical, and physical measures to protect personal information, including:</p>
            <ul className="list-disc ml-6 space-y-1 text-gray-600">
              <li>Secure servers</li>
              <li>SSL encryption</li>
              <li>Access control mechanisms</li>
              <li>Regular security audits</li>
            </ul>
            <p className="text-gray-600 mt-2">However, no system is completely secure. Users submit data at their own risk.</p>
          </section>

          {/* 7. Cookies Policy */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">7. Cookies Policy</h2>
            <p className="text-gray-600 leading-relaxed">
              Our website uses cookies to enhance user experience, analyse traffic, and improve site performance. 
              Users may disable cookies via browser settings, but some features may not function properly.
            </p>
          </section>

          {/* 8. User Rights */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">8. User Rights</h2>
            <p className="text-gray-600 mb-2">Users may request:</p>
            <ul className="list-disc ml-6 space-y-1 text-gray-600">
              <li>Access to their personal data</li>
              <li>Correction of inaccurate information</li>
              <li>Deletion of data (subject to legal/academic requirements)</li>
              <li>Withdrawal of consent</li>
            </ul>
            <p className="text-gray-600 mt-2">Requests can be submitted via email to the College.</p>
          </section>

          {/* 9. Children's Data */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">9. Children's Data</h2>
            <p className="text-gray-600 leading-relaxed">
              The website is not intended for children below 13 years without parental consent. 
              Personal information of minors is handled with appropriate safeguards.
            </p>
          </section>

          {/* 10. Third-Party Services */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">10. Third-Party Services</h2>
            <p className="text-gray-600 leading-relaxed">
              Our website may integrate third-party applications (payment gateways, analytics tools, WhatsApp chat, etc.). 
              These services operate under their own privacy policies.
            </p>
          </section>

          {/* 11. Changes to Policy */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">11. Changes to Policy</h2>
            <p className="text-gray-600 leading-relaxed">
              The College may update this Privacy Policy periodically. All modifications will be posted on this page.
            </p>
          </section>

          {/* 12. Contact Information */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate mb-3">12. Contact Information</h2>
            <p className="text-gray-600 leading-relaxed mb-3">
              For privacy-related queries, contact:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700 font-semibold mb-2">FIT Engineering College</p>
              <p className="text-gray-600 mb-2">Kaseru Baxur, Green Park, Mawana Road, Meerut, Uttar Pradesh, India</p>
              <p className="text-gray-600">
                <i className="fas fa-envelope mr-2 text-crimson"></i>Email: info@fitenggmeerut.com
              </p>
              <p className="text-gray-600">
                <i className="fas fa-phone mr-2 text-crimson"></i>Phone: 8077185886
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsConditionsPage;